import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  return (
    <div className="myFooter">
      <h3 className="footerHeading">Looking for an Electrical Service </h3>
      <button className="footerBtn" onClick={() => navigate("/contact")}>
        Contact Us
      </button>
    </div>
  );
}

export default Footer;
